'use client'

import Box from '@mui/material/Box'

import GenericHero from '@/components/Hero/GenericHero'
import RequestDemo from '@/components/RequestDemo'
import AsSeenInLogos from '@/sections/AsSeenInLogos'
import BackedByLogos from '@/sections/BackedByLogos'
import FortoCustomerQuoteAbout from '@/sections/FortoCustomerQuoteAbout'
import LuneCustomerStory from '@/sections/LuneCustomerStory'
import Luners from '@/sections/Luners'
import LuneStory from '@/sections/LuneStory'
import OurValues from '@/sections/OurValues'

export default function Page() {
    return (
        <>
            <GenericHero
                backgroundImageDesktop={'/images/heros/about-desktop.png'}
                backgroundImageMobile={'/images/heros/about-mobile.png'}
                title={'On a mission to make every product climate positive by default'}
                description={
                    <>
                        Industry leaders are driving revenue by quickly launching climate solutions
                        using Lune’s API. The only API that combines granular emission tracking and
                        high quality carbon removal.
                    </>
                }
                button={{
                    label: 'See open roles',
                    href: 'https://lune.co/join-us',
                    target: '_blank',
                    rel: 'noreferrer',
                }}
            />
            <AsSeenInLogos />
            <LuneStory />
            <OurValues />
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: {
                        xs: 0,
                        sm: 0,
                        md: 20,
                        lg: 20,
                        xl: 20,
                    },
                }}
            >
                <LuneCustomerStory />
                <Luners />
                <FortoCustomerQuoteAbout />
            </Box>
            <BackedByLogos />
            <RequestDemo />
        </>
    )
}
